import { render, staticRenderFns } from "./SignerInboxCard.vue?vue&type=template&id=30770be6"
import script from "./SignerInboxCard.vue?vue&type=script&lang=js"
export * from "./SignerInboxCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports